import React, { useState } from 'react';

function ProductImage({ product, className = 'product-image', variant = 'card' }) {
  const [missing, setMissing] = useState(false);

  if (missing) {
    return (
      <div className={`product-image-missing product-image-missing-${variant}`} role="img" aria-label={`${product.name} product photo pending upload`}>
        <span>Photo pending</span>
        <strong>{product.name}</strong>
        <small>{product.image.replace('/assets/images/products/', '')}</small>
      </div>
    );
  }

  return (
    <img
      src={product.image}
      alt={`${product.name} livestock nutrition product pack`}
      className={className}
      onError={() => setMissing(true)}
    />
  );
}

export default ProductImage;
